import { render, staticRenderFns } from "./personnelList.vue?vue&type=template&id=78355d10&"
import script from "./personnelList.vue?vue&type=script&lang=js&"
export * from "./personnelList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports